module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e771d810e0467436657c918dc23b9b80.gif";